module.exports = __webpack_public_path__ + "img/40_69_000_730.b1cb58a5.jpg";